import { allVerdiSchemas, type VerdiSchema, type VerdiSchemaKey } from "../index.js";
import type { UtilitiesForKey } from "./schemaRegistryTypes.generated.js";

/**
 * For some reason, having a fixed registry of all the utilities means that the
 * Typescript doesn't explode. If we do it with just types, it can only deal with a couple dozen schemas.
 */
const verdiUtilitiesRegistry = {
    ...Object.fromEntries(Object.entries(allVerdiSchemas).map(([_k, v]) => [v.schemaKey, v.utilities])),
} as UtilitiesForKey;

/**
 * Returns all utilities for the model that you give it
 * e.g. findUtilities(myDevice).getDistanceFromPoint(myDevice, point)
 *
 * (If this function isn't showing any utilities for a model you're giving it, make sure the model is in the index.ts and
 * has a distinct modelType that is set "as const")
 * @param model
 */
export function findUtilities<K extends VerdiSchemaKey>(model: { schemaKey: K } & VerdiSchema): UtilitiesForKey[K] {
    return verdiUtilitiesRegistry[model.schemaKey];
}
